import { Tabs, Tab, makeStyles } from '@material-ui/core'
import React from 'react'
import { StyleSheet, Text, View } from 'react-native'

const useStyles = makeStyles({
  root: {
    '& .MuiTabs-fixed': {
      // borderRadius: 16,
      // boxShadow: 'none',
      // backgroundColor: 'blue',
      // shadowColor: '#0F0',
      borderBottom: '1px solid #C4C4C4'
    },
    '& .MuiTab-root': {
      // set style for child component
      lineHeight: 1,
      minHeight: 35,
      minWidth: 80,
      textTransform: 'math-auto',
      // margin: '0px 10px',
      marginRight: 30,
      padding: '6px 1px',
      maxWidth: 'fit-content'
    },
    '&.MuiTabs-root': {
      // set style for root component
      minHeight: 35
    }
  }
})

export interface CategoryTabInfo {
  label: string
  value?: string
  key: string
  count?: number
}

export type OBCategoryTabProps = {
  dataSource: Array<CategoryTabInfo>
  permisison?: string[]
  onChangeTab: (val: number) => void
  activeTabIndex: number
}

export const OBCategoryTab = (props: OBCategoryTabProps) => {
  const { activeTabIndex, dataSource, onChangeTab } = props
  const classes = useStyles()
  const handleChange = (event: React.ChangeEvent<{}>, value: number) => {
    onChangeTab(value)
  }
  const getTabLabel = (isActive: boolean, label: string, count?: number) => {
    return (
      <View style={tabStyles.tabContent}>
        <View><Text style={[isActive && tabStyles.activeText]}>{label}</Text></View>
        {!!count &&
          <View style={tabStyles.tabCircleContent}>
            <Text style={tabStyles.tabCircleText}>{count}</Text>
          </View>}
      </View>
    )
  }
  return (
    <Tabs
      value={activeTabIndex}
      indicatorColor="primary"
      textColor="primary"
      onChange={handleChange}
      aria-label="simple tabs example"
      classes={{
        root: classes.root
      }}
      TabIndicatorProps={{
        style: {
          transition: 'none'
        }
      }}
    >
      {dataSource &&
        dataSource.map((dataItem, index) => {
          // console.log('dataItem.count:' + dataItem.count)
          return (
            <Tab
              key={`dataItem_${index}`}
              label={getTabLabel(activeTabIndex === index, dataItem.label, dataItem.count)}
              disableRipple
            ></Tab>
          )
        })}
    </Tabs>
  )
}
const tabStyles = StyleSheet.create({
  activeText: {
    // color: '#ED1B2E'
    color: '#4F4F4F',
    fontSize: 14,
    fontFamily: 'NotoSans_400Regular',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: 24
  },
  tabContent: {
    display: 'flex',
    flexDirection: 'row'
  },
  tabCircleContent: {
    marginLeft: 4,
    width: 24,
    height: 24,
    borderRadius: 24,
    borderWidth: 1,
    borderColor: '#ED1B2E'
  },
  tabCircleText: {
    color: '#ED1B2E',
    fontFamily: 'NotoSans_400Regular'
  }
})
